// assets/cp-removebg-loader.js
import { removeBackground } from 'https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.7.0/dist/index.mjs';

// Expose globally so GemPages code can call it
window.CP_REMOVE_BG = (file) =>
  removeBackground(file, {
    // Important: ensure model files load even inside builders/iframes
    publicPath: 'https://cdn.jsdelivr.net/npm/@imgly/background-removal@1.7.0/dist/'
  });

// Let listeners know it’s ready
window.dispatchEvent(new CustomEvent('cp-removebg-ready'));
console.log('[CushyPups] BG-removal module loaded');
